export default "__VITE_ASSET__CQxNacfc__"